import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";

@Component({
  selector: "app-warning-group",
  templateUrl: "./warning-group.component.html",
  styleUrls: ["./warning-group.component.scss"],
})
export class WarningGroupDialogComponent {
  form: FormGroup;

  title: string;
  message: string;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<WarningGroupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.title = data.title;
    this.message = data.message;
  }

  close(): void {
    this.dialogRef.close();
  }
}
